import { render, staticRenderFns } from "./DisplayStoreItemsDelete2.vue?vue&type=template&id=35fa53f0&"
import script from "./DisplayStoreItemsDelete2.vue?vue&type=script&lang=js&"
export * from "./DisplayStoreItemsDelete2.vue?vue&type=script&lang=js&"
import style0 from "./DisplayStoreItemsDelete2.vue?vue&type=style&index=0&id=35fa53f0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports